import { Redirect, useLocalSearchParams } from "expo-router";

/**
 * Keeps old `…/reports/roadsense/report/<reportId>` links working by sending
 * them to the RoadSense site list.
 */
export default function RoadSenseLifecycleRedirect() {
  const { tenantId } = useLocalSearchParams<{ tenantId: string }>();
  return <Redirect href={`/tenants/${tenantId}/reports/roadsense`} />;
}
